import styled from '@emotion/styled';
import { Table } from '@mui/material';

export const StyledTable = styled(Table)`
  th {
    font-weight: 700;
    line-height: 1rem;
  }

  img.empty-img {
    width: 128px;
  }
`;
